import React from "react";
import NotificationsPage from "./Notifications.js";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

const NotificationsManagementPage = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        // Default options for all mutations
        retry: 1, // Number of retry attempts
        onSuccess: (data) => {
          console.log("Mutation succeeded:", data);
        },
        onError: (error) => {
          console.error("Mutation failed:", error);
        },
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationsPage />
    </QueryClientProvider>
  );
};

export default NotificationsManagementPage;
